import styled from "styled-components";

export const VideoContentDisplayStyle =styled.div`
video{
    max-height: 100vh;
}
`